<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Kl4COD/tc-custom/9781646560318.jpg?1723374916640" alt="This image is the cover for the book Being Fitz"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Being Fitz
      </h1>
      <p class="bookDescription body article font2">
        <p>Lysander "Fitz" Fitzgibbon used to teach at a university, but quit when his father grew ill and needed someone to take care of him. Years later, after his dad's death, Fitz has given up on his dreams, drives a bus route, and endures visits from Jerry, who can't really be called a friend, and barely a benefit. Fitz is lonely, worries about his weight, and figures life won't be getting any better.<br/><br/>Then, Fitz stumbles over a dead body in the park. As if life couldn't get any worse, he has a run-in with Detective Holland Simms, whose infuriating arrogance and brash behavior provokes Fitz to punch him. But strangely enough, Fitz feels more alive around Simms than he has in a long time, though he finds it hard to believe that the confident Simms would want anything to do with him. Should he take a chance on more?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.D. Walker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f36ab3a